var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_2343_1540)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.875 20C50.875 20 59 28.125 59 38.125C59 39.2188 58.1406 40 57.125 40C56.0312 40 55.25 39.2188 55.25 38.125C55.25 30.2344 48.7656 23.75 40.875 23.75C39.7812 23.75 39 22.9688 39 21.875C39 20.8594 39.7812 20 40.875 20ZM41.5 35C42.8281 35 44 36.1719 44 37.5C44 38.9062 42.8281 40 41.5 40C40.0938 40 39 38.9062 39 37.5C39 36.1719 40.0938 35 41.5 35ZM39 29.375C39 28.3594 39.7812 27.5 40.875 27.5C46.7344 27.5 51.5 32.2656 51.5 38.125C51.5 39.2188 50.6406 40 49.625 40C48.5312 40 47.75 39.2188 47.75 38.125C47.75 34.375 44.625 31.25 40.875 31.25C39.7812 31.25 39 30.4688 39 29.375ZM28.1406 20.1562C29.625 19.7656 31.2656 20.4688 31.8125 21.9531L34.9375 29.4531C35.4844 30.7031 35.1719 32.1875 34.0781 33.0469L30.25 36.25C32.8281 41.7188 37.2812 46.1719 42.75 48.75L45.9531 44.9219C46.8125 43.8281 48.2969 43.5156 49.5469 44.0625L57.0469 47.1875C58.4531 47.7344 59.2344 49.375 58.8438 50.8594L56.9688 57.7344C56.5781 59.0625 55.4062 60 54 60C34.625 60 19 44.375 19 25C19 23.5938 19.9375 22.4219 21.2656 22.0312L28.1406 20.1562Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2343_1540",
    x1: 39.5506,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0145C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042E7D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e61fba9ae0b0bc574eb70a45f7b10244.svg";
export { ForwardRef as ReactComponent };